export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9978.8b324ec2.jpg";